import type { OrdersType } from "@/types/order";

export function generateOrderData(
    raw: OrdersType | string | null | undefined
): OrdersType | null {
    try {
        if (!raw) return null;

        if (typeof raw === 'string') {
            return JSON.parse(raw) as OrdersType;
        }

        return raw as OrdersType;
    } catch (error) {
        console.warn('[generateOrderData] Failed to parse:', error);
        return null;
    }
}